import React from 'react';
import HandballComp from './Handball.component';

class Handball extends React.Component {
    componentDidMount() {
        HandballComp();
    }
    render() {
        return (
            <div>
            </div>
        )
    }
}

export default Handball;